import { Stack, Typography } from '@lyearn/ui';

import { ItemRendererProps } from '../../types';
import CompletionStatus from '../CompletionStatus';

function ItemRenderer(props: ItemRendererProps) {
  const { itemIndex, sectionIndex, item, ...rest } = props;
  return (
    <Stack
      alignItems="center"
      className="mb-32 w-full last:mb-0"
      direction="row"
      justifyContent="between"
      {...rest}>
      <Stack alignItems="center" className="overflow-hidden" direction="row">
        <CompletionStatus className="me-12" isCompleted={item.isCompleted} />
        <Typography
          className="flex-1 truncate me-12"
          title={item.label as string}
          variant="body-short-02">
          {item.label}
        </Typography>
      </Stack>
      <Typography color="text-text-secondary" variant="body-long-03">
        {item.duration}
      </Typography>
    </Stack>
  );
}

export default ItemRenderer;
